import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../ReviewDetail.css";
import config from "../config";
import Gallery from "./Gallery";
import RatingWrapper from "./RatingWrapper";

function Kebabdetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [review, setReview] = useState(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    const fetchReview = async () => {
      try {
        const res = await fetch(`${config.BaseUrl}/reviews/${id}`);
        const data = await res.json();
        setReview(data.review);
        console.log(data.review);
      } catch (err) {
        console.error("Fehler beim Laden der Review:", err);
      }
    };
    fetchReview();
  }, [id]);

  const renderDetail = () => {
    if (!review) return <div>Loading Review</div>;

    return (
      <div className="detail-card">
        <button className="back-btn" onClick={() => navigate("/")}>
          ← Zurück
        </button>
        <div className="detail-body">
          <h2 className="detail-title">{review.title}</h2>
          <p className="detail-address">{review.address}</p>
          <p className="detail-rating">⭐ {review.rating} von 5</p>
          <p className="detail-views">
            <i class="fa-regular fa-eye" />  {review.views} Aufrufe
          </p>
          <p className="detail-text">{review.text}</p>
        </div>

        {review.image && <Gallery images={review.images} />}
        <div className="ratingsection">
          <RatingWrapper rating={review.cleanliness} title={"Sauberkeit"} />
          <RatingWrapper rating={review.atmosphere} title={"Atmosphäre"} />
          <RatingWrapper rating={review.taste} title={"Geschmack "} />
          <RatingWrapper rating={review.service} title={"Service"} />
        </div>
      </div>
    );
  };
  return <div className="detail-container">{renderDetail()}</div>;
}

export default Kebabdetail;
